import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticClass:"app-container",class:_vm.$route.path !== '/plan' || _vm.$route.path !== '/streamanity'
      ? 'app-width'
      : ''},[_c(VMain,{staticClass:"pa-0 app-background"},[[_c('Header',{staticClass:"app-background"}),_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }